import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
import { track } from '../../utils/analytics';
const EASE = [0.23, 1, 0.32, 1] as const;
export function StickyCtaBar() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const pastHero = window.scrollY > window.innerHeight * 0.9;
      const form = document.getElementById('discuss');
      const formVisible = form ? form.getBoundingClientRect().top < window.innerHeight : false;
      setVisible(pastHero && !formVisible);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    track('header_cta_click', {
      source: 'sticky_bar'
    });
    document.getElementById('discuss')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-534" data-mp="vor3cqp11w6j">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.25,
      ease: EASE
    }} className="sm:hidden fixed bottom-0 inset-x-0 z-40 p-3 bg-sand/95 backdrop-blur-md border-t border-line" data-id="element-535" data-mp="vng1iwf56yi2">
          <a href="#discuss" onClick={onClick} className="flex items-center justify-center gap-2.5 w-full px-6 py-4 text-base font-semibold text-white bg-accent" data-id="element-536" data-mp="hnwsm1eibj4p">
            {c.stickyCta}
            <ArrowRightIcon className="w-4 h-4" data-id="element-537" data-mp="7swk3b8d411d" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}